import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react";

import { init } from "echarts";
import Empty from "@/component/empty";
import { isEmpty } from "lodash";
import Color from "@/tool/color";
import moWelfare from "../store/wealfare";
import moIndex from "../../store";
import { toJS } from "mobx";

interface IProps {}
interface IState {}
let echartdom: any = null;

const WelfareBudget = (props: IProps, state: IState) => {
  const { PerCapitaWelfareDate } = moWelfare;
  const { isMock } = moIndex;
  const data = PerCapitaWelfareDate;
  const topRef = useRef<any>(null);
  const render = () => {
    if (echartdom) echartdom.dispose();
    echartdom = init(topRef.current);
    const option = {
      tooltip: {
        trigger: "item",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          label: { show: true },
        },
        show: true,
        formatter: (parmes: any) => {
          const htl = `
                     <p style="font-family: 'Roboto';
                     color:${Color.blackColor(
                       1
                     )};font-size:14px;font-weight:500">${parmes.seriesName}</p>
                     <p style="margin-top:10px;display:flex;
                         justify-content: space-between;align-items: center;">
                      <span
                        style="display:inline-block;
                        width:10px;height:10px;
                        background:${Color.primary};
                        border-radius:50%;margin-right:5px">
                      </span>
                      <span style="font-family: 'PingFang SC';
                      color:${Color.blackColor(0.6)};font-size:12px">${
            parmes.name
          }</span>
                      <span style="margin:0 15px"></span>
                      <span style="font-family: 'Roboto';
                       color:${Color.blackColor(0.8)};font-size:14px">
                       ${Number(Math.round(parmes.value)).toLocaleString()}
                      </span>
                   </p>
                 `;
          return htl;
        },
      },
      legend: {
        data: [],
      },
      grid: {
        left: "3%",
        right: "3%",
        bottom: 20,
        top: 20,
        containLabel: true,
      },
      yAxis: [
        {
          type: "value",
          splitLine: {
            show: true,
            lineStyle: {
              color: Color.blackColor(0.1),
              width: 1,
              type: "dashed",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: Color.ccc,
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: Color.ccc,
            },
          },
          axisLabel: {
            show: true,
            color: Color.blackColor(0.5),
            fontFamily: "Roboto",
          },
        },
      ],
      xAxis: [
        {
          type: "category",
          axisLine: {
            show: true,
            lineStyle: {
              color: Color.ccc,
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: Color.blackColor(0.85),
            fontFamily: "Roboto",
          },
          data: ["25分位", "50分位", "75分位"],
        },
      ],
      series: [
        {
          name: "人均福利预算",
          type: "bar",
          label: {
            show: true,
            position: "top",
            fontFamily: "Roboto",
            fontSize: 14,
            formatter: (parmes: any) => {
              return `${Number(Math.round(parmes.data)).toLocaleString()}`;
            },
          },
          emphasis: {
            focus: "self",
            blurScope: "coordinateSystem",
          },
          color: Color.primary,
          lineStyle: {
            color: Color.primary,
            width: 2,
          },
          itemStyle: {
            borderRadius: [2, 2, 0, 0],
          },
          barWidth: 16,
          data,
        },
      ],
    };
    echartdom.setOption(option);
  };

  useEffect(() => {
    if (data[0] || data[1] || data[2]) {
      render();
    }
    window.addEventListener("resize", render);
    return () => {
      window.removeEventListener("resize", render);
    };
  }, [PerCapitaWelfareDate]);

  return (
    <section className="welfare-budget">
      <section>
        <span className="sub-title">人均福利预算</span>
      </section>
      {(data[0] || data[1] || data[2]) ? (
        <section
          ref={topRef}
          className="budget-svg"
          style={{
            backgroundImage: isMock
              ? "url(https://file.smartsalary.cn/web-img%402.0/market/image/ismock.png)"
              : "",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
          }}
        />
      ) : (
        <Empty margin="20px 0 0" />
      )}
    </section>
  );
};

export default observer(WelfareBudget);
